module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-database-5.556893a1.svg";